import { Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={2}
      p={3}
    >
      <Typography variant="h5">Page not found</Typography>
      <Button variant="contained" onClick={() => navigate('/login')}>
        Back to login
      </Button>
    </Box>
  );
};

export default PageNotFound;
